<plotly-plot
  [data]="data()"
  [layout]="layout()"
  [config]="config"
  [useResizeHandler]="true">
</plotly-plot>
